module.exports = __webpack_public_path__ + "static/Data_Materialism-4034143c1a31dd5d3283cf868df50293.png";